<template>
  <div class="list-page-box" :class="{ 'pt-112': type == 4 }">
    <van-nav-bar :class="{ 'nav-bar-search': type == 4 }" @click-right="onSearch(params.keyWords)">
      <template #left>
        <i class="icon-back" @click="$router.back()"></i>
      </template>
      <!-- 搜索框 -->
      <template #title v-if="type == 4">
        <div class="list-search-box">
          <div class="search-input-box" @click="setInputFocus">
            <div v-if="!searchFocus && params.keyWords">
              <span>{{ params.keyWords }}</span>
              <i @click="params.keyWords = ''"></i>
            </div>
            <input type="text" :style="`display: ${searchFocus || !params.keyWords ? 'block' : 'none'};`"
              placeholder="请输入商品关键词" id="searchInput" @keyup.enter="onSearch(params.keyWords)" @focus="onSearchFocus"
              @blur="onSearchBlur" v-model="params.keyWords" maxlength="50" />
          </div>
          <i class="icon-clean" v-if="searchFocus && params.keyWords" @click="params.keyWords = ''"></i>
        </div>
      </template>
      <!-- 标题 type == 3 工厂编号 -->
      <template #title v-else>
        <span class="title" :data-hint="type == 3 ? '【工厂No.' + params.memCode + '】' : ''">{{ getTitleText() }}</span>
      </template>
      <!-- 搜索按钮 -->
      <template #right v-if="type == 4">
        <span style="color: #FF6634">搜索</span>
      </template>
    </van-nav-bar>

    <!-- 空页面加载 -->
    <van-loading v-if="loading" type="spinner" color="#111111" />
    <!-- 推荐关键字 -->
    <div class="search-key-box" v-else-if="showSearch">
      <span v-if="searchKey && searchKey.length > 0">推荐关键词</span>
      <div><span v-for="item, index in searchKey" :key="index" @click="onSearch(item)">{{ item }}</span></div>
    </div>
    <template v-else>
      <div class="opt-box">
        <div class="class-box" :class="{ 'class-box-active': showCat }" @click="showCat = !showCat">
          <span class="overflow">{{ params.catName1 || '全部分类' }}</span>
          <Icon class="class-icon" :color="showCat ? '#FF6634' : '#666'" name="arrow-down" size="0.373333rem"></Icon>
        </div>
        <div class="new-box" :class="{ 'new-box-active': params.sort == 'online' }" @click="onNewClick">
          <span>最新</span>
          <i></i>
        </div>
        <div class="price-box" @click="onPriceClick">
          <span>价格</span>
          <div>
            <Icon class="price-top" name="play" :color="params.order == 'asc' ? '#FF6634' : '#B7B7B7'"
              size="0.373333rem">
            </Icon>
            <Icon class="price-bot" name="play" :color="params.order == 'desc' ? '#FF6634' : '#B7B7B7'"
              size="0.373333rem">
            </Icon>
          </div>
        </div>
        <div class="other-bxo"
          :class="{ 'other-bxo-active': params.priceMax || params.priceMin || params.kcMin || params.goodsCz || params.tags.length > 0 }"
          @click="showAther = !showAther">
          <span>材质/风格等</span>
          <i></i>
        </div>
      </div>

      <div class="list-page-popup-container" id="listPagePopupContainer">
        <List id="scrollBox" ref="scrollBox" v-if="list && list.length > 0" v-back-to-top v-model="nextLoading"
          :finished="finished" finished-text="没有更多了" :error.sync="error" error-text="网络异常，点击重新加载" @load="getData()">
          <div class="list-box">
            <GoodsItem v-for="item, index in list" :key="index" :data="item"
              @to="$router.replace({ query: { ...$route.query, scrollTop: $refs.scrollBox.$el.scrollTop || 1, tiem: new Date().getTime() } })">
            </GoodsItem>
          </div>

        </List>
        <!-- 无数据 -->
        <van-empty v-else class="custom-image" image="https://xhdata.wan4.com/wsw-h5-26.png" description="抱歉！未搜索到商品">
        </van-empty>
        <!-- 分类选择 -->
        <Popup v-model="showCat" round position="top" style="position: absolute;"
          :overlay-style="{ position: 'absolute' }" :get-container="getPopupContainer">
          <div class="cat-popup-box">
            <span class="overflow" :class="{ active: item == params.catName1 || (item == '全部分类' && !params.catName1) }"
              v-for="item, index in info.catList" :key="index" @click="setCatName(item)">{{ item }}</span>
          </div>
        </Popup>
      </div>
    </template>




    <atherFilterPopup v-model="showAther" :cz-list="info.czList" :tags="info.tags" :vl="params"
      @onConfirm="e => { this.params = e, getData() }"></atherFilterPopup>
  </div>
</template>
<script>
import { Icon, List, Popup } from 'vant';
import GoodsItem from '@/components/GoodsItem.vue'
import atherFilterPopup from '../../components/atherFilterPopup.vue';
export default {
  name: 'ClassifyList',
  components: {
    GoodsItem, Icon, List, Popup, atherFilterPopup
  },
  props: {},
  data() {
    return {
      type: 1,//type; 1:分类列表 2：【1-精选款式 2-当季新款 3-折扣专区】3:工厂 4: 搜索
      loading: true,
      nextLoading: true,//列表是否在加载中
      error: false, //列表是否加载错误
      finished: false,//列表是否加载完成
      showCat: false,//分类弹框
      showAther: false, //材质/风格等弹框
      searchKey: this.$store.state.searchKey,//搜索关键字
      showSearch: false,//搜索关键字展示
      searchFocus: false,//搜索聚焦
      info: {},
      list: [],
      params: {
        block: '',
        catName1: '',
        page: 1,
        pageSize: 20,
        sort: 'online',//排序字段: "price"-按价格  "online"-最新
        order: '',//排序值： "asc"-顺序  "desc"-倒序 ""-无
        goodsCz: '',//材质
        tags: [],//标签组列表
        priceMin: '',//价格从, 单位: 分
        priceMax: '',//价格至，单位: 分
        kcMin: '',//库存数从
        memCode: '',//工厂编号
        keyWords: '',//搜索关键字
      }
    }
  },
  watch: {},
  computed: {},
  created() {
  },
  activated() {
    let scrollTop = this.$route.query.scrollTop;
    if (this.$route.query.tiem && scrollTop > 0) {
      this.$nextTick(() => {
        let scrollBox = document.getElementById('scrollBox');
        if (scrollBox) {
          scrollBox.scrollTo({
            top: scrollTop,
          })
        }
      })
      //如果是加载中就重新加载
      if (this.loading) {
        this.initParams();
        this.initData()
      }
    } else {
      this.showSearch = false;
      this.params.keyWords = ''
      this.loading = true;
      this.initParams();
      this.initData()
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.showCat) {
      this.showCat = false;
      next(false)
    } else if (this.showAther) {
      this.showAther = false;
      next(false)
    } else {
      next()
    }
  },
  methods: {
    initData() {
      this.getQuery();
      if (this.type != 4) {
        this.getData();
      } else {
        this.loading = false;
        this.setInputFocus()
      }
    },
    getQuery() {
      this.type = this.$route.query.type
      this.params.memCode = this.$route.query.memCode || '';
      this.params.block = this.$route.query.block || '';
      this.params.catName1 = this.$route.query.catName || '';
    },
    //获取标题文案
    getTitleText() {
      if (this.type == 2) {
        if (this.params.block == 1) {
          return '精选款式'
        } else if (this.params.block == 2) {
          return '当季新款'
        } else if (this.params.block == 3) {
          return '特价专区'
        }
      } else if (this.type == 3) {
        return '工厂详情'
      }
      return '商品列表'
    },

    getData() {
      this.showCat = false;
      this.nextLoading = true;
      if(this.params.page == 1){
        this.list = [];
      }
      this.$ajax('/iap-api/wan4/v1534/onlineGoodsList.do', {
        ...this.params,
        priceMax: this.params.priceMax ? this.params.priceMax * 100 : '',
        priceMin: this.params.priceMin ? this.params.priceMin * 100 : '',
      }).then(res => {
        this.loading = false;
        //防止快速切换 接口返回时间不一致
        if (JSON.stringify({
          ...this.params,
          priceMax: this.params.priceMax ? this.params.priceMax * 100 : '',
          priceMin: this.params.priceMin ? this.params.priceMin * 100 : '',
        }) != JSON.stringify(res.params)) {
          return
        }

        this.nextLoading = false;
        if (res.params.page == 1) {
          this.list = res.data.rows;
        } else {
          this.list = [...this.list, ...res.data.rows];
        }
        this.finished = res.data.ttl <= this.list.length;
        this.params.page++;

        // 初始化标签数据
        res.data.tags.forEach(item => {
          let arr = item.vl.split(',');
          item.subList1 = arr;
          item.subList2 = arr.slice(0, 6);
          item.isShow = arr.length > 6;
        })
        //分类加全部分类
        if (this.type == 2 || this.type == 3) {
          res.data.catList.unshift('全部分类')
        }
        this.info = {};
        this.info = res.data;
      }, () => {
        this.nextLoading = false;
        this.error = true;
      })
    },
    // 返回一个特定的 DOM 节点，作为挂载的父节点
    getPopupContainer() {
      return document.getElementById('listPagePopupContainer');
    },
    //最新
    onNewClick() {
      this.params.page = 1;
      this.params.sort = 'online';
      this.params.order = '';
      this.getData();
    },
    //价格排序
    onPriceClick() {
      this.params.page = 1;
      this.params.sort = 'price';
      this.params.order = this.params.order != 'asc' ? 'asc' : 'desc'
      this.getData();
    },
    //分类
    setCatName(name) {
      this.initParams();
      this.params.catName1 = name == '全部分类' ? '' : name;
      this.getData();
    },
    initParams() {
      this.params.catName1 = '';
      this.params.page = 1;
      this.params.tags = [];
      this.params.goodsCz = '';
      this.params.priceMax = '';
      this.params.priceMin = '';
      this.params.kcMin = '';
      this.params.order = '';
      this.params.sort = 'online';
    },
    //设置聚焦
    setInputFocus() {
      this.searchFocus = true;
      this.$nextTick(() => {
        document.getElementById("searchInput").focus();
      })
    },
    //搜索聚焦
    onSearchFocus() {
      this.showSearch = true;
      this.searchFocus = true;
    },
    //搜索失焦
    onSearchBlur() {
      //失焦后延迟设置状态，不然清除图标点击不到
      setTimeout(() => {
        this.searchFocus = false;
      }, 200)
    },
    //搜索
    onSearch(key) {
      this.initParams();
      this.params.keyWords = key;
      this.loading = true;
      this.showSearch = false;
      this.getData();
    }

  },
}
</script>
<style lang="less" scoped>
.title {

  &::after {
    content: attr(data-hint);
    color: #666;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    position: absolute;
  }

}

.list-search-box {
  border-radius: 72px;
  border: 2px solid #FF6634;
  background: #F8F8F8;
  display: flex;
  height: 72px;
  width: 534px;
  align-items: center;

  &::before {
    content: '';
    width: 40px;
    height: 40px;
    background: url('../../assets/icon/icon-search.png') no-repeat;
    background-position: center center;
    background-size: 100% 100%;
    margin-right: 8px;
    margin-left: 24px;
  }

  .search-input-box {
    width: 0;
    flex: 1;
    height: 100%;
    display: flex;
    align-items: center;

    >input {
      color: rgba(0, 0, 0, 0.90);
      font-size: 28px;
      font-style: normal;
      font-weight: 400;
      line-height: 40px;
      width: 100%;
      height: 100%;
      background: transparent;
      border: none;
      padding-right: 15px;
    }

    >div {
      display: flex;
      border: 1px solid #DCDCDC;
      border-radius: 28px;
      background: #FFF;
      align-items: center;
      height: 52px;
      max-width: 350px;
      padding: 0 12px 0 18px;

      >span {
        color: #333;
        font-size: 28px;
        font-style: normal;
        font-weight: 400;
        overflow: hidden;
        text-align: right;
        direction: rtl;
        flex: 1;
      }

      >i {
        width: 30px;
        height: 30px;
        background: url('https://xhdata.wan4.com/wsw-h5-37.png') no-repeat center;
        background-size: 100%;
        margin-left: 8px;
      }
    }


  }


  .icon-clean {
    width: 42px;
    height: 42px;
    margin-right: 24px;
    background: url('https://xhdata.wan4.com/wsw-h5-37.png') no-repeat center;
    background-size: 100%;
  }
}

::v-deep .nav-bar-search {
  height: 112px;

  .van-nav-bar__content {
    height: 112px !important;
  }
}


.pt-112 {
  padding-top: 112px !important;
}

.list-page-box {
  display: flex;
  flex-direction: column;
  position: relative;
  box-sizing: border-box;
  height: 100vh;
  padding-top: 88px;

  .search-key-box {
    display: flex;
    flex-direction: column;
    padding: 24px;

    >span {
      color: #333;
      font-size: 24px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }

    >div {
      display: flex;
      flex-wrap: wrap;

      >span {
        border-radius: 28px;
        border: 1px solid #DCDCDC;
        background: #FFF;
        padding: 0 24px;
        color: #999;
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        margin-right: 12px;
        margin-top: 12px;
        height: 42px;
        display: flex;
        align-items: center;
      }
    }

  }


  .opt-box {
    display: flex;
    background: #fff;
    height: 66px;
    flex-shrink: 0;

    >div {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 12px;
      box-sizing: border-box;

      >span {
        color: #666;
        font-size: 28px;
        font-style: normal;
        font-weight: 400;
        margin-right: 8px;
      }
    }

    .class-box {
      width: 210px;
      min-width: 210px;

      .class-icon {
        transform: rotate(0deg);
        transition: all 0.3s;
      }

      &-active {
        >span {
          color: #FF6634;
        }

        .class-icon {
          transform: rotate(180deg);
        }
      }
    }

    .new-box {
      width: 150px;

      >i {
        width: 26px;
        height: 40px;
        background: url('https://xhdata.wan4.com/wsw-h5-23.png') no-repeat center;
        background-size: 100% 100%;
      }

      &-active {
        >span {
          color: #FF6634;
        }

        >i {
          width: 26px;
          height: 40px;
          background: url('https://xhdata.wan4.com/wsw-h5-24.png') no-repeat center;
          background-size: 100% 100%;
        }
      }
    }

    .price-box {
      width: 150px;

      >div {
        display: flex;
        flex-direction: column;
        position: relative;

        .price-top {
          transform: rotate(-90deg);
          position: absolute;
          bottom: -7px;
          left: 0.5px;
        }

        .price-bot {
          transform: rotate(90deg);
          position: absolute;
          top: -7px;
        }
      }
    }

    .other-bxo {
      width: 240px;

      >i {
        width: 28px;
        height: 28px;
        background: url('https://xhdata.wan4.com/wsw-h5-22.png') no-repeat center;
        background-size: 28px 28px;
      }

      &-active {
        >span {
          color: #FF6634;
        }

        >i {
          background: url('https://xhdata.wan4.com/wsw-h5-25.png') no-repeat center;
          background-size: 28px 28px;
        }

      }
    }

  }

  .list-page-popup-container {
    position: relative;
    overflow: hidden;
    flex: 1;
    display: flex;
    flex-direction: column;

    .van-list {
      overflow-y: scroll;
    }

    .list-box {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-gap: 18px 18px;
      margin: 20px 24px 0;
    }
  }


}

.cat-popup-box {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 18px 18px;
  padding: 16px 32px 40px;

  >span {
    background: #F8F8F8;
    border-radius: 4px;
    width: 100%;
    height: 68px;
    color: #333;
    font-size: 26px;
    font-style: normal;
    font-weight: 400;
    line-height: 68px;
    text-align: center;
    padding: 0 8px;
    box-sizing: border-box;
  }

  .active {
    color: #FFF;
    background: #FF6634;
    font-weight: bold;
  }

}
</style>